export function toParams(
  path: string,
  params:
    | Exclude<ConstructorParameters<typeof URLSearchParams>[0], undefined>
    | SearchParamsBuilder,
) {
  const searchParams = new URLSearchParams(
    params instanceof SearchParamsBuilder ? params.searchParams : params,
  );
  return `${path}?${searchParams.toString()}`;
}

export class SearchParamsBuilder {
  readonly searchParams: URLSearchParams;

  constructor(searchParams?: URLSearchParams) {
    this.searchParams = new URLSearchParams(searchParams);
  }

  public filter(callback: (key: string, value: string) => boolean | void) {
    this.searchParams.forEach((value, key) => {
      const result = callback(key, value);
      if (!result) {
        this.searchParams.delete(key);
      }
    });

    return this;
  }

  public add(key: string, value: string) {
    if (!value) return this;

    if (this.searchParams.has(key)) {
      this.searchParams.delete(key);
    }

    this.searchParams.append(key, value);

    return this;
  }
}
